module.exports = __webpack_public_path__ + "media/images/ringrevenue/control_play_blue_14-5467b225832f9a154f7186ffe05c8724.png";